module.exports = __webpack_public_path__ + "static/media/Milex-Pessaries-Brochure.c938e0da.png";